import * as ActionTypes from './actionTypes.js';
const defaultState = {
  attestationModalRequest: false,
  isAttesttationDone: false,
  hippaAttestationStarted: 'NO',
};

export default function hippaAttestationReducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_HIPPA_CONTENT_FAILED:
    case ActionTypes.FETCH_HIPPA_CONTENT_SUCCESS:
    case ActionTypes.HIPPA_MODAL_REQUEST:
    case ActionTypes.SET_HIPPA_ATTESTATION_STATUS:
    case ActionTypes.FETCH_HIPPA_CONTENT:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}
